/**
 * Helper для безопасного получения Vite констант
 * В Vite: переменные заменяются на значения при сборке
 * В Next.js/Node.js: переменные не существуют, возвращается fallback
 */
export function getViteConst(getter: () => string | undefined, fallback: string): string;
export function getViteConst(getter: () => boolean | undefined, fallback: boolean): boolean;
export function getViteConst<T>(getter: () => T | undefined, fallback: T): T;
export function getViteConst<T>(getter: () => T | undefined, fallback: T): T {
  try {
    const value = getter();
    if (typeof value === "string") {
      return value as T;
    }
    return value !== undefined && value !== null ?
      value :
      fallback;
  } catch {
    return fallback;
  }
}

export const getConst = <T extends (string | boolean)>(
  viteConst: T | undefined,
  webpackConst: string | undefined,
  fallback: T,
): T | string => {
  try {
    if (viteConst !== undefined) {
      return viteConst;
    } else if (webpackConst) {
      return webpackConst;
    } else {
      return fallback;
    }
  } catch (e) {
    console.error(e);
    return fallback;
  }
};
